<template>
  <v-app-bar app color="#283e66" flat dark clipped-left>
    <v-app-bar-nav-icon v-if="isLoggedIn" @click="switchDrawer()" />
    <v-toolbar-title>
      <a href="https://struccle.com" style="color: white; text-decoration: none;">
        <span style="font-weight: bold; font-size: 1.4em">Struccle</span>
      </a> 
      <small style="font-size: 0.7em"> {{ version }}</small>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-toolbar-title v-if="isLoggedIn" class="d-flex align-center">
      <div class="mx-2">
        <div style="font-size: 0.8em; color: white;">URL</div>
        <v-progress-linear
          :value="(userCounter.scd_url_cnt / maxUrl) * 100"
          height="8"
          color="blue"
          rounded
          striped
        ></v-progress-linear>
        <small style="color: white;">{{ userCounter.scd_url_cnt.toLocaleString() }}/{{ maxUrl.toLocaleString() }}</small>
      </div>
      <div class="mx-2">
        <div style="font-size: 0.8em; color: white;">Token</div>
        <v-progress-linear
          :value="(userCounter.total_token_count / maxToken) * 100"
          height="8"
          color="green"
          rounded
          striped
        ></v-progress-linear>
        <small style="color: white;">{{ userCounter.total_token_count.toLocaleString() }}/{{ maxToken.toLocaleString() }}</small>
      </div>
    </v-toolbar-title>
    <v-btn v-show="isLoggedIn" outlined @click="wrapCopy(user.uid)" class="mx-3" :style="{ textTransform: 'none' }">UserID</v-btn>
    <v-menu offset-y v-show="isLoggedIn">
      <template v-slot:activator="{ on, attrs }">
        <v-btn text v-bind="attrs" v-on="on">マニュアル</v-btn>
      </template>
      <v-list>
        <v-list-item :href="supportUrls.guide" target="_blank">
          <v-list-item-title>ガイド</v-list-item-title>
        </v-list-item>
        <v-list-item :href="supportUrls.faq" target="_blank">
          <v-list-item-title>FAQ</v-list-item-title>
        </v-list-item>
        <v-list-item :href="supportUrls.discord" target="_blank">
          <v-list-item-title>コミュニティ</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-btn to="/plan" text>料金プラン</v-btn>
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn text v-bind="attrs" v-on="on">利用規約等</v-btn>
      </template>
      <v-list>
        <v-list-item :to="{ name: 'rules' }">
          <v-list-item-title>利用規約</v-list-item-title>
        </v-list-item>
        <v-list-item :to="{ name: 'privacy' }">
          <v-list-item-title>個人情報保護方針</v-list-item-title>
        </v-list-item>
        <v-list-item :to="{ name: 'transaction' }">
          <v-list-item-title>特定商取引法に基づく表記</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
<!--    <v-btn color="red" href="https://datastructor.com/free-support/" target="_blank">12/31まで相談無料</v-btn>-->
  </v-app-bar>
</template>

<script>
export default {
  data() {
    return {
      maxUrl: 500000,
      maxToken: 1000000,
      supportUrls: {
        guide: "",
        faq: "",
        discord: ""
      },
      userCounter: {
        scd_url_cnt: 0,
        total_token_count: 0
      }
    }
  },
  created() {
    this.loadSupportUrls();
    this.loadUserCounter();
  },
  computed: {
    version() {
      return this.$store.getters["state/version"]
    },
    user: {
      get() {
        return this.$store.getters["state/storeUser"]
      },
      set(value) {
        this.$store.dispatch("state/setUser", value);
      }
    },
    isLoggedIn(){
      return this.$store.getters["state/storeIsLoggedIn"]
    },
    isOnDrawer() {
      return this.$store.getters["state/storeDrawerFlag"]
    }
  },
  methods: {
    async loadUserCounter() {
      try {
        const user = this.$store.getters["state/storeUser"];
        if (!user || !user.uid) {
          console.warn("ユーザーが未ログインなのでカウンター取得をスキップ");
          return;
        }
        const docRef = this.doc(this.db, "counter", user.uid)
        this.onSnapshot(docRef, (snap) => {
          if (snap.exists()) {
            const data = snap.data()
            this.userCounter = {
              scd_url_cnt: data.scd_url_cnt || 0,
              total_token_count: data.total_token_count || 0
            }
          }
        })
      } catch (e) {
        console.error("カウンターの取得に失敗:", e);
      }
    },
    async loadSupportUrls() {
      try {
        const snap = await this.getDocument(["admin_config", "marketing"]);
        if (snap && snap.urls) {
          this.supportUrls = snap.urls;
        }
      } catch (e) {
        console.error("サポートURLの取得に失敗:", e);
      }
    },
    switchDrawer() {
      this.$store.dispatch("state/switchDrawer", !this.isOnDrawer);
    },
    wrapCopy(value) {
      this.doCopy(value)
      this.changeStateSnackbar("success", `Copied! ${this.user.uid}`, 1500)
    }
  }
}
</script>